import { useQuery } from '@tanstack/react-query';

import { overrideFormulaFieldsWithMessageContent } from '../../helpers/formulaHelpers';
import { BaseError } from 'helpers/BaseError';

import { ProcessedFormulaV1 } from '../../models/formula.model';

import API from '../../services/api';

import useGetAndUpdateMessageContent from '../message-content/useMessageContentGetAndUpdate';
import formulaKeys from './_queryKeys';

const getFormula = async (
    formulaId: number,
    messageContentId: string,
): Promise<ProcessedFormulaV1> => {
    const { data } = await API.fetchApprovedFormulaV1(formulaId, {
        message_content_id: messageContentId,
    });
    return data;
};

export default function useApprovedFormulaQueryV1(formulaId: number) {
    const { data: messageContent, isDataLoading: isMessageContentLoading } =
        useGetAndUpdateMessageContent(formulaId);

    const queryResult = useQuery<ProcessedFormulaV1, BaseError>({
        queryKey: formulaKeys.approvedFormulaById(
            formulaId,
            messageContent?.id,
        ),
        queryFn: () => getFormula(formulaId, messageContent?.id as string),
        enabled: !!formulaId && !!messageContent?.id,
        select: (data) =>
            overrideFormulaFieldsWithMessageContent(data, messageContent),
    });

    const isLoading = isMessageContentLoading || queryResult.isLoading;

    return {
        ...queryResult,
        isLoading,
    };
}
